import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'DeepFakeGeneral'

export const GET_DEEPFAKE_CONFIG_ASYNC = createAsyncTypes('GET_DEEPFAKE_CONFIG', typeKey)
export const UPDATE_DEEPFAKE_CONFIG_ASYNC = createAsyncTypes('UPDATE_DEEPFAKE_CONFIG', typeKey)
export const GET_DEEPFAKE_MAILBOX_LIST_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_MAILBOX_LIST',
  typeKey
)
export const GET_DEEPFAKE_KEY_MEMBERS_ASYNC = createAsyncTypes('GET_DEEPFAKE_KEY_MEMBERS', typeKey)
export const CREATE_DEEPFAKE_KEY_MEMBER_ASYNC = createAsyncTypes(
  'CREATE_DEEPFAKE_KEY_MEMBER',
  typeKey
)
export const UPDATE_DEEPFAKE_KEY_MEMBER_ASYNC = createAsyncTypes(
  'UPDATE_DEEPFAKE_KEY_MEMBER',
  typeKey
)
export const DELETE_DEEPFAKE_KEY_MEMBER_ASYNC = createAsyncTypes(
  'DELETE_DEEPFAKE_KEY_MEMBER',
  typeKey
)
export const GET_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'GET_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const GET_WARNING_REPORT_CANDIDATES_ASYNC = createAsyncTypes(
  'GET_WARNING_REPORT_CANDIDATES',
  typeKey
)
export const ADD_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'ADD_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const DELETE_WARNING_REPORT_RECIPIENTS_ASYNC = createAsyncTypes(
  'DELETE_WARNING_REPORT_RECIPIENTS',
  typeKey
)
export const GET_DEEPFAKE_ALLOW_LIST_ASYNC = createAsyncTypes('GET_DEEPFAKE_ALLOW_LIST', typeKey)
export const ADD_DEEPFAKE_ALLOW_LIST_ASYNC = createAsyncTypes('ADD_DEEPFAKE_ALLOW_LIST', typeKey)
export const DELETE_DEEPFAKE_ALLOW_LIST_ASYNC = createAsyncTypes(
  'DELETE_DEEPFAKE_ALLOW_LIST',
  typeKey
)

export const SET_DEEPFAKE_MAILBOX_LIST_PAGE = `${typeKey}/SET_DEEPFAKE_MAILBOX_LIST_PAGE`
export const SET_EMPLOYEE_INFO = `${typeKey}/SET_EMPLOYEE_INFO`
export const SET_EMPLOYEE_INFO_FIELD = `${typeKey}/SET_EMPLOYEE_INFO_FIELD`
export const SET_DEEPFAKE_MAILBOX_LIST_VALUE = `${typeKey}/SET_DEEPFAKE_MAILBOX_LIST_VALUE`
export const SET_DEEPFAKE_WARNING_REPORT_RECIPIENT = `${typeKey}/SET_DEEPFAKE_WARNING_REPORT_RECIPIENT`

export const MAILBOXES_PER_PAGE = 20
